import {
  GAME_END_HEIGHT,
  GAME_LANE_HEIGHT,
  GAME_ROAD_HEIGHT,
  GAME_ROAD_WIDTH,
  GAME_GRID_SIZE,
  GAME_GRID_START_X,
} from '../../constants/AppConstants';

export default class Row extends Phaser.Group {
  constructor({ game, rowNum }) {
    super(game);
    this.game = game;
    this.cellsInRow = (GAME_ROAD_WIDTH / GAME_GRID_SIZE) | 0;
    this.cells = [];
    for (let i = 0; i < this.cellsInRow; i++) {
      this.cells[i] = 0;
    }

    this.rowNum = rowNum;
    this.rowPosY = this.game.sceneHeight - 44;
    this.rowPosY -= this.rowNum * GAME_LANE_HEIGHT;
    this.y = this.rowPosY;
  }

  //Updates the movement of each car in the row every frame
  step(timeStep) {}

  stopAnims() {}

  startAnims() {}

  gridToPos(x) {
    const x1 = GAME_GRID_START_X + (x + 0.5) * GAME_GRID_SIZE;
    const y1 = this.rowPosY;
    return { x: x1, y: y1 };
  }

  posToGrid() {
    const x1 = Math.floor((x - GAME_GRID_START_X) / GAME_GRID_SIZE - 0.5);
    const y1 = this.rowNum;
    return { x: x1, y: y1 };
  }

  getMidGrid() {
    return Math.floor(this.cellsInRow / 2);
  }

  gridPosMiddle() {
    const x1 = GAME_GRID_START_X + (this.getMidGrid() + 0.5) * GAME_GRID_SIZE;
    const y1 = this.rowPosY;
    return { x: x1, y: y1 };
  }

  getColliders() {
    return [];
  }
}
